export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_MENU = 'FETCH_CATEGORIES';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCT_TAXES = 'FETCH_PRODUCT_TAXES';